import { Button } from '@heroui/react';
import { Edit, Eye, Trash2 } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { DeviceData } from '../../../../../types';

type ActionRowProps = {
  data: DeviceData;
  /** Potwierdzenie i kasowanie robi strona — single i bulk dzielą jeden modal
   *  i jedną mutację (v3-deleteDevices). */
  onDelete: (device: DeviceData) => void;
  isDeleting: boolean;
};

export const ActionRow = ({ data, onDelete, isDeleting }: ActionRowProps): React.JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-end gap-[5px] h-[40px]">
      <Button
        isIconOnly
        size="sm"
        variant="light"
        aria-label={`Preview ${data.name ?? data.id}`}
        onPress={() => navigate(`/devices/${data.id}`)}
      >
        <Eye size={14} />
      </Button>
      <Button
        isIconOnly
        size="sm"
        variant="light"
        aria-label={`Edit ${data.name ?? data.id}`}
        onPress={() => navigate(`/devices/${data.id}/edit`)}
      >
        <Edit size={14} />
      </Button>
      <Button
        isIconOnly
        size="sm"
        variant="light"
        aria-label={`Delete ${data.name ?? data.id}`}
        isDisabled={isDeleting}
        onPress={() => onDelete(data)}
      >
        <Trash2 size={14} color="red" />
      </Button>
    </div>
  );
};
